<template>
  <v-tooltip bottom content-class="tooltip-bottom" :disabled="!showTooltip">
    <template #activator="{ on, attrs }">
      <span
        class="shortcut-icon__wrapper"
        v-bind="attrs"
        v-on="on"
        @click.stop.prevent="handleClick"
      >
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="16"
          width="2"
          color="primary"
          class="shortcut-icon__loader"
        />
        <img 
          v-else
          src="/img/navicon/Shortcuts.svg" 
          :class="['shortcut-icon', { 'shortcut-icon--active': isActive }]"
          alt="Add to Shortcuts"
        />
      </span>
    </template>
    <span>{{ isActive ? 'Remove from Shortcuts' : 'Add to Shortcuts' }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'ShortcutIcon',
  props: {
    // The menu item data
    item: {
      type: Object,
      required: true
    },
    // Component name (financialclose, flux, etc.)
    component: {
      type: String,
      default: 'financialclose'
    },
    // Icon size
    size: {
      type: String,
      default: '16px'
    },
    // Show tooltip
    showTooltip: {
      type: Boolean,
      default: true
    },
    // Check if already in shortcuts
    isActive: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (this.loading) {
        return;
      }

      const shortcutName = this.getName();
      if (!shortcutName) {
        const message = 'Shortcut name unavailable.';
        this.$store?.commit?.('sbWarning', message);
        this.$toast?.warning?.(message);
        return;
      }

      const shortcutData = {
        name: shortcutName,
        url: this.getUrl(),
        icon: this.item.icon || '',
        meta: {
          description: this.item.description || '',
          component: this.component,
          ...this.item.meta
        }
      };
      
      this.$emit('add-shortcut', shortcutData);
    },

    getName() {
      const item = this.item || {};
      return item.shortcutName
        || item.name
        || item.title
        || item.displayname
        || item.displayName
        || item.label
        || item.text
        || null;
    },

    getUrl() {
      // If item has href, process it with $nova if available
      if (this.item.href) {
        try {
          // Try to use $nova.gotoLink if available
          if (this.$nova && this.$nova.gotoLink) {
            return this.$nova.gotoLink({ 
              path: this.item.href, 
              hash: this.item.hash 
            }, true);
          }
          // Otherwise return href directly
          return this.item.href;
        } catch (error) {
          console.warn('Error processing href:', error);
          return this.item.href;
        }
      }
      
      // If item has hash, construct URL with hash
      if (this.item.hash) {
        const path = this.item.path || this.$route.path;
        return `${path}#${this.item.hash}`;
      }
      
      // Use current route path as fallback
      return this.$route.path;
    }
  }
};
</script>

<style scoped>
.shortcut-icon__wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.shortcut-icon__loader {
  margin: 0;
}
</style>
